import { cx } from '@linaria/core';
import { mdiCog } from '@mdi/js';
import Icon from '@mdi/react';
import { memo } from 'react';
import { URL_MFC_SHARE } from '../../constants/urls';
import ButtonRefresh from '../Buttons/ButtonRefresh';
import FlexGrid from '../common/FlexGrid';
import { StyledDivider } from '../common/StyledDivider';
import Link from './Link';
import "./Maintenance.linaria.module.css!=!./Maintenance?./Maintenance.linaria.module.css?css=H4sIAAAAAAAAA42Sza6bMBCF932KSFWldsEVhlzKpcs+iGXMYAaMTewJkFh99yq5JQGy6cbS8fE3nr83QT3/8JzRPOGoQ4V+0OJS1BrmX3++vN3sWnLWZLY9X3cytGdPWF8iaQ2BoUKCIXAL16S8JoU62arQC6fQRGSHIh/WvyDJ6yneqpc//CAkRDCC0ZeFLYEzlccqy3Yy3OqIJieG4nY8MtsU9FBBaFQmQoLe72pRyBm1s2yzf+kXLBvmQ7z4fcebpO/bLAzWI6E1hQMtCEdYnlDHWT3NZoRwK50lz9p/as4+vMrS9yCttq74muY5pHLxB366diypgzDYi8/olgShUb+1ld2EHg6pP2g0INzBwQjOwwFNjQYJnmGaox1O9j/D7PHxwpn1J5uMYcKKmoLF8bfFhORhNoCqoY3bec7er6imYEdwtbZT4aWzWi8PkoqzqY3b0u5kKIXslLNnU0WfvRmF+x5Fq2tywnh9vg3sx2peMEvKy/W4FlNbzkiq9l3tZBhEVaFR991MjisCtgS8EKUlsv0W6rZQ9wJpqGmL6C2iXxB37+2a6TvuyUx5/lw9UXqrz7RevWOTH6/pffOidS/q02Ldk1m8v55yYioYBAAA"
const refreshStyles = "atm_9s_1txwivl atm_fc_1h6ojuz atm_h3_ftgil2";
const paragraphStyles = "atm_9s_1txwivl atm_fc_itczq0 atm_be_1g80g66 atm_h_1h6ojuz";
const dividerStyles = "atm_gi_1tjxcj6";
const gearRotationStyles = "atm_mk_h2mmj6 atm_tk_1fwxnve atm_7l_19sg635 atm_p_qzk12f";
const gearIconStyles = "atm_p_h4opqo";
const gridStyles = "atm_vy_1osqo2v atm_e2_1osqo2v atm_ks_15zigw atm_h_1h6ojuz atm_fc_1h6ojuz atm_2d_1wj0jbo";
const paperStyles = "atm_mk_h2mmj6 atm_gi_exct8b atm_lo_1tcgj5g atm_le_1tcgj5g atm_lk_1tcgj5g atm_ll_1tcgj5g";
const iconsWrapperStyles = "atm_mk_stnw88 atm_tk_4h84z3 atm_fq_4h84z3";
const Maintenance = () => {
  return <FlexGrid className={cx('no-scrollbars', gridStyles)} data-testid="Grid__MaintenanceMode">
            <div className={cx('paper-container maintenance-mode', paperStyles)}>
                <div className={iconsWrapperStyles}>
                    <Icon path={mdiCog} size={1.5} className={gearIconStyles} />
                    <Icon path={mdiCog} size={1.5} className={gearRotationStyles} />
                </div>
                <h1 className={'typography gutter-bottom-big'}>
                    MyFreeCams Server Maintenance
                </h1>
                <p className={'typography paragraph gutter-bottom-big'}>
                    We are temporarily offline for maintenance. We will be back
                    up shortly!
                </p>
                <p className={'typography paragraph gutter-bottom-big'}>
                    We apologize for any inconvenience. Thank you for your
                    patience and support!
                </p>
                <p className={'typography paragraph gutter-bottom-big'}>
                    Please visit our{' '}
                    <Link data-testid="Link__StatusPage" href="https://status.myfreecams.com/" underline inline>
                        status page
                    </Link>{' '}
                    for real-time updates on this maintenance.
                </p>
                <p className={'typography paragraph'}>
                    Check out MFC Share at:{' '}
                    <Link data-testid="Link__ShareMyFreeCams" href={URL_MFC_SHARE} underline inline>
                        Share.MyFreeCams.com
                    </Link>
                </p>
                <StyledDivider className={dividerStyles} />
                <p className={cx('typography paragraph', paragraphStyles)}>
                    <Link href="http://mfcsha.re/myfreecams" inline underline>
                        http://MFCsha.re/MyFreeCams
                    </Link>
                    <Link href="https://twitter.com/myfreecams/" inline underline>
                        Twitter.com/MyFreeCams
                    </Link>
                </p>
                <div className={refreshStyles}>
                    <ButtonRefresh />
                </div>
            </div>
        </FlexGrid>;
};
export default memo(Maintenance);